import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ApiResponse, VisibaApiHttp } from '../Classes/visibaHttp.class';
import { SpaContext } from '../Classes/spacontext';
import { IcdCode } from '../Common/Models/Api/Models/IcdCode';

@Injectable()
export class OutcomesService {
	readonly baseUri = '/api/Office';

	constructor(
		public _http: VisibaApiHttp,
		public _spaContext: SpaContext,
	) {}

	public searchIcdCodes(query: string, count?: number): Observable<ApiResponse<IcdCode[]>> {
		let params = new HttpParams();
		params = params.append('searchQuery', query);
		params = count != undefined ? params.append('count', `${count}`) : params;

		return this._http.getTyped<IcdCode[]>(
			`${this.baseUri}/${this._spaContext.unitConfig.LicenceHolder.Id}/Outcomes/icdcodes/search`,
			null,
			{
				params,
			},
		);
	}
}
